"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const ProductBox_1 = require("./Elements/ProductBox");
const Store_1 = require("./Store");
const ContentArea_1 = require("./Elements/ContentArea");
let ProductList = class ProductList extends React.Component {
    constructor(props) {
        super(props);
        Store_1.default.loadProducts();
    }
    componentDidMount() {
        document.title = Store_1.default.currentPageName + ' | Jaffa';
        Store_1.default.updateNavigationColor(Store_1.default.containerId);
    }
    render() {
        let backgroundImageUrl = Store_1.default.BackgroundImageUrl;
        let hasBgImage = backgroundImageUrl && backgroundImageUrl.length > 0;
        let dimFilter = Store_1.default.DimFilter;
        let headerText = Store_1.default.Translations.headerText || Store_1.default.currentPageName.toUpperCase();
        let ingressText = Store_1.default.Translations.ingressText;
        let bgStyle = React.createElement("style", null);
        let filterStyle = {};
        if (hasBgImage) {
            filterStyle.backgroundColor = 'black';
            filterStyle.opacity = 0.25;
            bgStyle = React.createElement("style", { dangerouslySetInnerHTML: {
                    __html: `@media all and (max-width: 600px) {
                   .product-listing-background-image {
                       background-image: url('${backgroundImageUrl}?width=800&CropMode=percentage&crop=18,0,18,0');
                       background-size: cover;
                       background-repeat: no-repeat;
                   }
                 }
                 @media all and (min-width: 601px) and (max-width: 1024px) {
                    .product-listing-background-image {
                        background: url('${backgroundImageUrl}?width=1024');
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
                }
                @media all and (min-width: 1025px) {
                    .product-listing-background-image {
                        background: url('${backgroundImageUrl}?width=1200');
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
               }`
                } });
            window.addFullWidth();
        }
        else {
            window.removeFullWidth();
        }
        return (React.createElement(React.Fragment, null,
            hasBgImage && bgStyle,
            hasBgImage &&
                React.createElement("div", { className: "row u-pt-10 _md-u-pt-17 u-mb-3 u-relative product-listing-background-image" },
                    dimFilter && React.createElement("div", { className: "s-bg-cover background-image", style: filterStyle }),
                    React.createElement("div", { className: "col-lg-12 col-sm-12 col-xs-12 u-z-1" },
                        React.createElement("div", { className: "o-container u-full-width" },
                            React.createElement("h1", { className: "u-tc s-hero s-themecolor-1 o-product-listing-heading" }, headerText),
                            React.createElement("div", { className: "o-ingress row" },
                                React.createElement("div", { className: "col-md-6 col-sm-9 col-xs-12 u-tc s-themecolor-1 u-my-0" }, ingressText))))),
            !hasBgImage && React.createElement("h1", { className: "u-tc s-hero o-product-listing-heading" }, headerText),
            React.createElement("div", { className: "o-container" },
                React.createElement("div", { className: "o-product-listing-wrapper" },
                    Store_1.default.loading &&
                        React.createElement("div", { className: "ui active inverted dimmer" },
                            React.createElement("div", { className: "ui text loader" }, Store_1.default.Translations.loadingText)),
                    React.createElement("div", { className: "row u-pb-12" }, Store_1.default.Products && Store_1.default.Products.map(function (product, index) {
                        return (React.createElement(ProductBox_1.default, { key: product.id, product: product }));
                    })))),
            React.createElement(ContentArea_1.default, { content: Store_1.default.containerId, language: Store_1.default.currentLanguage, area: "ProductContentArea" })));
    }
};
ProductList = __decorate([
    mobx_react_1.observer
], ProductList);
exports.default = ProductList;
